export const IS_UPLOADING = 'IS_UPLOADING';
export const FAILED_UPLOAD = 'FAILED_UPLOAD';
export const SUCCESS_UPLOAD = 'SUCCESS_UPLOAD';
export const RESET_PROGRESS = 'RESET_PROGRESS';